module.exports = __webpack_public_path__ + "img/A1M1_new.62d8008d.jpg";